// extracted by mini-css-extract-plugin
export default {"modalContent":"style_modalContent__SDZ3W","title":"style_title__iVHIT","description":"style_description__cPOp3","actionIcon":"style_actionIcon__4nEMu"};